import * as React from 'react';

import { translate } from '~l10n/client';
import { Badge } from '~shared/components/Badge';
import { IconAreasOfImprovement } from '~shared/components/icons/x-large/IconAreasOfImprovement/IconAreasOfImprovement';
import { IconSpecificStudents } from '~shared/components/icons/x-large/IconSpecificStudents/IconSpecificStudents';
import { TileButton } from '~shared/components/TileButton';
import { proCheck } from '~teacher/util/proCheck';

import { GenerationType } from './GenerateQuestionsDialog';
import { GenerateQuestionDialogContent } from './Layout/GenerateQuestionDialogContent';

interface SelectGenerationTypeProps {
  setGenerationType: (newSelectedType: GenerationType) => void;
}

export function SelectGenerationType({
  setGenerationType,
}: SelectGenerationTypeProps) {
  const isPro = proCheck.isPro();

  return (
    <GenerateQuestionDialogContent
      header={
        <GenerateQuestionDialogContent.Header
          title={translate('Generate Questions')}
          description={translate(
            'Generate retake or practice assessments to strengthen understanding.'
          )}
        />
      }
    >
      <p className="font-display text-base leading-normal text-blue-900 font-700 pt-4">
        Generate from
      </p>
      <div className="flex flex-col gap-2 pt-2">
        <TileButton
          layout="horizontal"
          icon={
            <IconAreasOfImprovement
              titleId="AreasOfImprovement"
              title="Areas of Improvement"
            />
          }
          title={translate('Areas of Improvement')}
          description={translate('Select areas you want a group to work on.')}
          onClick={() => setGenerationType('areas-of-improvement')}
        />
        <TileButton
          layout="horizontal"
          icon={
            <IconSpecificStudents
              titleId="SpecificStudents"
              title="Specific Students"
            />
          }
          title={
            <>
              {translate('Specific Students')}
              {!isPro && (
                <Badge className="font-sans" tone="pro">
                  Pro
                </Badge>
              )}
            </>
          }
          description={translate(
            'Target areas of improvement for specific students.'
          )}
          onClick={() => setGenerationType('specific-students')}
        />
      </div>
    </GenerateQuestionDialogContent>
  );
}
